import React, {useEffect, useState} from "react";
import './apns.scss';
import {ReactComponent as Delete} from '../../../../../assets/svg/delete.svg';
import {ReactComponent as Info} from '../../../../../assets/svg/info.svg';
import {Button, Tooltip} from "antd";
import {AddApnModal} from "./add-apn-modal";
import {useStores} from "../../../../store";
import DOMPurify from "dompurify";
import {Link} from "react-router-dom";

export const ApnsComponent = ({onDetailsChange, oemName}) => {
    const {adminStore, useCaseStore} = useStores();
    const [apns, setApns] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const columns = [
        {
            title: 'APN type',
            dataIndex: 'type',
            key: 'apnType',
            width: '10%'
        },
        {
            title: 'APN short name',
            dataIndex: 'shortApn',
            key: 'apnShortName',
            width: '32%'
        },
        {
            title: 'APN family',
            dataIndex: 'apnFamily',
            key: 'apnFamily',
            width: '32%'
        },
        {
            title: 'APN category',
            dataIndex: 'category',
            render: (category: any) => category == null || category == "" ? 'None' : category,
            key: 'apnCategory',
            width: '21%'
        },
        {
            title: '',
            dataIndex: 'shortApn',
            render: (shortApn: any, item: any) => item.enableDelete ?
                <Delete className='delete' onClick={() => onApnDeleteClick(shortApn)}/> :
                <Tooltip title={<span>To delete this APN you need to delete its <Link className="draft" to={`../../${DOMPurify.sanitize(oemName)}/settings`}>Settings</Link> first</span>} placement={"left"}> <Info
                    className='header-info'/> </Tooltip>,
            key: 'apnDelete',
            width: '5%'
        }
    ];

    useEffect(() => {
        adminStore.load().then();
    }, []);

    useEffect(() => {
        if (oemName) {
            useCaseStore.getPreferences(oemName).then(async res => {
                const preferencesApns = getPreferencesApns(res?.useCasePreferences);
                const mappedApns = mapApns(adminStore.fullApnsList, oemName, preferencesApns);
                setApns(mappedApns);
            });
        }
    }, [adminStore.fullApnsList]);

    useEffect(() => {
        onDetailsChange(apns);
    }, [apns]);

    function getPreferencesApns(useCasePreferences) {
        return useCasePreferences
            ?.flatMap(item => item.preferences.apnPreferences)
            .map(item => item.apnName);
    }

    function mapApns(fullApnsList, oemName, preferencesApns) {
        return fullApnsList
            .filter(apn => apn.oem === oemName)
            .map(apn => ({
                ...apn,
                enableDelete: apn.apnFamily.split(',').every(family => !preferencesApns?.includes(family))
            }));
    }

    function onApnDeleteClick(shortApn: any) {
        setApns(apns.filter(item => item.shortApn !== shortApn));
    }

    function getCellRender(item: any, column: any) {
        if (column.render) {
            return column.render(item[column.dataIndex], item);
        }
        return item[column.dataIndex];
    }

    function saveApn(value) {
        setApns(prevState => [...prevState, {
            type: 'assigned',
            shortApn: value.shortName,
            apnFamily: value.apnFamily,
            category: value.selectedCategory,
            enableDelete: true
        }]);
    }

    return (
        <div>
            <div className='apns-table-row'>
                {columns.map(column => (
                    <div key={column.key} className='apns-table-column'
                         style={{width: column.width}}>{column.title}</div>
                ))}
            </div>
            {apns.map(item => (
                <div className='apns-table-row' key={item.shortApn}>
                    {columns.map(column => (
                        <div key={column.key} className={`apns-table-cell ${column.key}`}
                             style={{width: column.width}}>
                            {getCellRender(item, column)}
                        </div>
                    ))}
                </div>
            ))}
            <div className='apns-buttons'>
                <Button type="primary" onClick={() => setIsModalOpen(true)}>Add dedicated APN</Button>
            </div>
            {isModalOpen && <AddApnModal isOpen={isModalOpen} setIsOpen={setIsModalOpen} saveApn={saveApn}/>}
        </div>
    );
}